import { Routes, Route, Navigate } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'

import ScrollToTop from './components/ScrollToTop'
import Navbar from './components/Navbar'
import Footer from './components/Footer'

import HomePage from './pages/HomePage'
import TreatmentsOverviewPage from './pages/TreatmentsOverviewPage'
import TreatmentDetailPage from './pages/TreatmentDetailPage'
import HypnosisPage from './pages/HypnosisPage'
import HealingPage from './pages/HealingPage'
import PhoneTreatmentPage from './pages/PhoneTreatmentPage'
import ProfilePage from './pages/ProfilePage'
import PricesPage from './pages/PricesPage'
import ReferencesPage from './pages/ReferencesPage'
import ContactPage from './pages/ContactPage'
import NotFoundPage from './pages/NotFoundPage'
import ForbiddenPage from './pages/ForbiddenPage'

const SCRAPED_TREATMENT_SLUGS = [
  'angst',
  'rygestop',
  'vaegttab',
  'jalousi',
  'barnloeshed',
  'soevnloeshed',
  'depression',
  'sengevaedning',
  'hjemve',
  'lavt-selvvaerd',
  'adhd',
  'skolevaering',
  'saerlig-sensitiv',
  'eksamens-angst',
  'stress',
  'flyskraek',
  'ring-og-spoerg',
]

export default function App() {
  return (
    <HelmetProvider>
      <div className="flex min-h-screen flex-col bg-gradient-to-br from-[#F5F8F2] via-[#FAF9F4] to-[#F1F5EB] text-[#242F1F]">
        <ScrollToTop />
        <Navbar />

        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/behandlinger" element={<TreatmentsOverviewPage />} />
            <Route path="/behandlinger/:slug" element={<TreatmentDetailPage />} />
            <Route path="/hypnoterapi" element={<HypnosisPage />} />

            {/* Direct aliases for scraped treatment URLs */}
            {SCRAPED_TREATMENT_SLUGS.map((slug) => (
              <Route
                key={slug}
                path={`/${slug}`}
                element={<Navigate to={`/behandlinger/${slug}`} replace />}
              />
            ))}

            <Route path="/hypnose" element={<HypnosisPage />} />
            <Route path="/healing" element={<HealingPage />} />
            <Route
              path="/telefonisk-behandling"
              element={<PhoneTreatmentPage />}
            />
            <Route path="/profil" element={<ProfilePage />} />
            <Route path="/om-trine" element={<Navigate to="/profil" replace />} />
            <Route path="/priser" element={<PricesPage />} />
            <Route path="/referencer" element={<ReferencesPage />} />
            <Route path="/kontakt" element={<ContactPage />} />

            <Route path="/403" element={<ForbiddenPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </HelmetProvider>
  )
}
